import React from 'react';
import PropTypes from 'prop-types';
import YouTubePlaylist from 'react-youtube-playlist';
import 'react-youtube-playlist/dist/styles.scss';
import { Container } from '../ui';

const HelpContainer = () => {
  return (
    <Container title='Help'>
      <div className='panel panel-default'>
        <div className='panel-heading'>
          <h3 className='panel-title'>"How To"s</h3>
        </div>
        <div className='panel-body'>
          <YouTubePlaylist
            api_key='AIzaSyCWuH5SGDikY4OPSrbJxqTi4Y2uTgQUggw'
            playlist_id='PL64BwQcJEEVImdziHEAlXzb5Zhzs1KNKT'
            width='95%'
            height='500'
            show_thumbnails
            container_class='help-container-video'
          />
        </div>
      </div>
    </Container>
  )
}

export default HelpContainer;



// WEBPACK FOOTER //
// ./src/browser/components/help/help-container.js